var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPrescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M249.782 74.6137V27.4869C249.782 12.5894 237.708 0.515625 222.81 0.515625C187.952 0.515625 159.666 28.8014 159.666 63.6597V85.4217H238.974C244.913 85.4217 249.782 80.6019 249.782 74.6137Z",
    fill: "url(#paint0_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M249.782 74.6137V27.4869C249.782 12.5894 237.708 0.515625 222.81 0.515625C187.952 0.515625 159.666 28.8014 159.666 63.6597V85.4217H238.974C244.913 85.4217 249.782 80.6019 249.782 74.6137Z",
    fill: "url(#paint1_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M249.782 74.6137V27.4869C249.782 12.5894 237.708 0.515625 222.81 0.515625C187.952 0.515625 159.666 28.8014 159.666 63.6597V85.4217H238.974C244.913 85.4217 249.782 80.6019 249.782 74.6137Z",
    fill: "url(#paint2_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M249.782 74.6137V27.4869C249.782 12.5894 237.708 0.515625 222.81 0.515625C187.952 0.515625 159.666 28.8014 159.666 63.6597V85.4217H238.974C244.913 85.4217 249.782 80.6019 249.782 74.6137Z",
    fill: "url(#paint3_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M249.782 74.6137V27.4869C249.782 12.5894 237.708 0.515625 222.81 0.515625C187.952 0.515625 159.666 28.8014 159.666 63.6597V85.4217H238.974C244.913 85.4217 249.782 80.6019 249.782 74.6137Z",
    fill: "url(#paint4_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M197.933 203.92C197.933 206.793 196.764 209.568 194.719 211.612L159.715 246.617C157.865 248.467 155.479 249.587 152.899 249.781H62.6377C58.1588 249.781 54.5074 246.13 54.5074 241.651V27.4869C54.5074 12.5894 66.5812 0.515625 81.4787 0.515625H224.904C210.006 0.515625 197.933 12.5894 197.933 27.4869V203.92Z",
    fill: "url(#paint5_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M115.363 0.515625H224.904C210.006 0.515625 197.933 12.5894 197.933 27.4869V203.872C197.933 206.744 196.764 209.519 194.719 211.564L159.715 246.617C157.865 248.467 155.479 249.587 152.899 249.781H115.412L115.363 0.515625Z",
    fill: "url(#paint6_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54.5074 174.612V241.7C54.5074 246.179 58.1588 249.83 62.6377 249.83H152.899C155.479 249.635 157.865 248.515 159.715 246.665L194.719 211.661C196.764 209.616 197.933 206.841 197.933 203.969V174.661H54.5074V174.612Z",
    fill: "url(#paint7_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M148.371 158.984L113.757 193.599H54.5074V241.7C54.5074 246.179 58.1588 249.83 62.6377 249.83H152.899C155.479 249.635 157.865 248.516 159.715 246.666L194.719 211.661C195.79 210.59 196.618 209.276 197.202 207.864L148.371 158.984Z",
    fill: "url(#paint8_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M192.869 208.935H165.168C160.689 208.935 157.037 212.586 157.037 217.065V244.767C157.037 247.542 154.798 249.83 151.974 249.83C177.339 249.83 197.884 229.285 197.884 203.92C197.933 206.647 195.644 208.935 192.869 208.935Z",
    fill: "url(#paint9_linear_3901_61777)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M72.8129 85.4216H143.308C145.694 85.4216 147.641 87.369 147.641 89.7546C147.641 92.1401 145.694 94.0875 143.308 94.0875H72.8129C70.4273 94.0875 68.4799 92.1401 68.4799 89.7546C68.4312 87.369 70.4273 85.4216 72.8129 85.4216Z",
    fill: "url(#paint10_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M163.805 85.4216H179.627C182.013 85.4216 183.96 87.369 183.96 89.7546C183.96 92.1401 182.013 94.0875 179.627 94.0875H163.805C161.419 94.0875 159.472 92.1401 159.472 89.7546C159.472 87.369 161.419 85.4216 163.805 85.4216Z",
    fill: "url(#paint11_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M72.8129 107.573H143.308C145.694 107.573 147.641 109.521 147.641 111.906C147.641 114.292 145.694 116.239 143.308 116.239H72.8129C70.4273 116.239 68.4799 114.292 68.4799 111.906C68.4312 109.521 70.4273 107.573 72.8129 107.573Z",
    fill: "url(#paint12_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M163.805 107.573H179.627C182.013 107.573 183.96 109.521 183.96 111.906C183.96 114.292 182.013 116.239 179.627 116.239H163.805C161.419 116.239 159.472 114.292 159.472 111.906C159.472 109.521 161.419 107.573 163.805 107.573Z",
    fill: "url(#paint13_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M72.8129 129.725H143.308C145.694 129.725 147.641 131.672 147.641 134.058C147.641 136.443 145.694 138.39 143.308 138.39H72.8129C70.4273 138.39 68.4799 136.443 68.4799 134.058C68.4312 131.672 70.4273 129.725 72.8129 129.725Z",
    fill: "url(#paint14_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M163.805 129.725H179.627C182.013 129.725 183.96 131.672 183.96 134.058C183.96 136.443 182.013 138.39 179.627 138.39H163.805C161.419 138.39 159.472 136.443 159.472 134.058C159.472 131.672 161.419 129.725 163.805 129.725Z",
    fill: "url(#paint15_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M72.8129 151.876H143.308C145.694 151.876 147.641 153.824 147.641 156.209C147.641 158.595 145.694 160.542 143.308 160.542H72.8129C70.4273 160.542 68.4799 158.595 68.4799 156.209C68.4312 153.824 70.4273 151.876 72.8129 151.876Z",
    fill: "url(#paint16_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M163.805 151.876H179.627C182.013 151.876 183.96 153.824 183.96 156.209C183.96 158.595 182.013 160.542 179.627 160.542H163.805C161.419 160.542 159.472 158.595 159.472 156.209C159.472 153.824 161.419 151.876 163.805 151.876Z",
    fill: "url(#paint17_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M72.8129 174.028H143.308C145.694 174.028 147.641 175.975 147.641 178.361C147.641 180.746 145.694 182.694 143.308 182.694H72.8129C70.4273 182.694 68.4799 180.746 68.4799 178.361C68.4312 175.975 70.4273 174.028 72.8129 174.028Z",
    fill: "url(#paint18_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M163.805 174.028H179.627C182.013 174.028 183.96 175.975 183.96 178.361C183.96 180.746 182.013 182.694 179.627 182.694H163.805C161.419 182.694 159.472 180.746 159.472 178.361C159.472 175.975 161.419 174.028 163.805 174.028Z",
    fill: "url(#paint19_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M72.8129 196.131H143.308C145.694 196.131 147.641 198.078 147.641 200.464C147.641 202.849 145.694 204.796 143.308 204.796H72.8129C70.4273 204.796 68.4799 202.849 68.4799 200.464C68.4312 198.078 70.4273 196.131 72.8129 196.131Z",
    fill: "url(#paint20_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M163.805 196.131H179.627C182.013 196.131 183.96 198.078 183.96 200.464C183.96 202.849 182.013 204.796 179.627 204.796H163.805C161.419 204.796 159.472 202.849 159.472 200.464C159.472 198.078 161.419 196.131 163.805 196.131Z",
    fill: "url(#paint21_linear_3901_61777)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M102.51 45.7923L133.669 76.9505C149.004 73.9321 161.078 61.8583 164.048 46.5713L132.89 15.4131L118.625 31.5277L102.51 45.7923Z",
    fill: "url(#paint22_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M197.932 80.4073L150.124 32.5503H150.075L133.815 46.6689L119.696 62.9295L197.932 141.166V80.4073Z",
    fill: "url(#paint23_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M147.641 31.4792H133.766V17.6527C133.766 15.8027 132.257 14.2935 130.407 14.2935H121.936C120.086 14.2935 118.576 15.8027 118.576 17.6527V31.5278H104.701C102.851 31.5278 101.342 33.0371 101.342 34.8871V43.3582C101.342 45.2082 102.851 46.7175 104.701 46.7175H118.576V60.5926C118.576 62.4426 120.086 63.9518 121.936 63.9518H130.407C132.257 63.9518 133.766 62.4426 133.766 60.5926V46.6688H147.641C149.491 46.6688 151 45.1596 151 43.3095V34.8384C151 32.9884 149.491 31.4792 147.641 31.4792Z",
    fill: "url(#paint24_linear_3901_61777)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M54.5074 138.05V196.082H111.322L130.699 176.657L92.092 138.05H54.5074Z",
    fill: "url(#paint25_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M46.7665 173.249L63.9035 156.112C70.5734 149.442 70.5734 138.683 63.9035 132.013C57.2337 125.343 46.4744 125.343 39.8046 132.013L22.6676 149.15L29.4348 166.482L46.7665 173.249Z",
    fill: "url(#paint26_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M46.7665 173.249L63.9035 156.112C70.5734 149.442 70.5734 138.683 63.9035 132.013C57.2337 125.343 46.4744 125.343 39.8046 132.013L22.6676 149.15L29.4348 166.482L46.7665 173.249Z",
    fill: "url(#paint27_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M5.53061 166.237L22.6676 149.1L46.7665 173.248L29.6295 190.385C22.9597 197.055 12.1517 197.055 5.53061 190.385C-1.13919 183.715 -1.13919 172.907 5.53061 166.237Z",
    fill: "url(#paint28_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M50.856 145.012L67.9931 162.149C74.6629 168.819 85.4222 168.819 92.092 162.149C98.7618 155.479 98.7618 144.72 92.092 138.05L74.955 120.913L57.6232 127.68L50.856 145.012Z",
    fill: "url(#paint29_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M57.818 103.776L74.955 120.913L50.8561 145.012L33.719 127.875C27.0492 121.205 27.0492 110.397 33.719 103.776C40.3402 97.1548 51.1482 97.1548 57.818 103.776Z",
    fill: "url(#paint30_linear_3901_61777)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M131.234 200.22L148.371 183.083C155.041 176.413 155.041 165.654 148.371 158.984C141.702 152.314 130.942 152.314 124.273 158.984L107.136 176.121L113.903 193.453L131.234 200.22Z",
    fill: "url(#paint31_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M89.9986 193.258L107.136 176.121L131.234 200.22L114.097 217.357C107.428 224.027 96.6197 224.027 89.9986 217.357C83.3774 210.687 83.3774 199.879 89.9986 193.258Z",
    fill: "url(#paint32_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M103.046 183.376H99.8816L89.9986 193.259C83.3288 199.929 83.3288 210.689 89.9986 217.358C96.6684 224.028 107.428 224.028 114.097 217.358L125.538 205.917L103.046 183.376Z",
    fill: "url(#paint33_linear_3901_61777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M66.4838 212.197H90.7288C100.125 212.197 107.768 204.553 107.768 195.157C107.768 185.761 100.125 178.117 90.7288 178.117H66.4838L59.0351 195.157L66.4838 212.197Z",
    fill: "url(#paint34_linear_3901_61777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M42.2876 178.117H66.5325V212.197H42.2876C32.8914 212.197 25.2479 204.553 25.2479 195.157C25.2479 185.761 32.8914 178.117 42.2876 178.117Z",
    fill: "url(#paint35_linear_3901_61777)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3901_61777",
    x1: 160.76,
    y1: 30.8038,
    x2: 248.087,
    y2: 63.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2414,
    stopColor: "#F0F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4916,
    stopColor: "#E4F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#CFE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3901_61777",
    x1: 245.545,
    y1: 42.9711,
    x2: 193.075,
    y2: 42.9711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3901_61777",
    x1: 213.553,
    y1: 59.4869,
    x2: 181.971,
    y2: 28.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3901_61777",
    x1: 235.91,
    y1: 42.9711,
    x2: 251.471,
    y2: 42.9711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3901_61777",
    x1: 204.724,
    y1: 63.907,
    x2: 204.724,
    y2: 88.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3901_61777",
    x1: 55.0605,
    y1: 64.7887,
    x2: 236.528,
    y2: 190.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2414,
    stopColor: "#F0F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4916,
    stopColor: "#E4F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#CFE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3901_61777",
    x1: 159.431,
    y1: 125.148,
    x2: 230.021,
    y2: 125.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3901_61777",
    x1: 126.223,
    y1: 227.71,
    x2: 126.223,
    y2: 250.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3901_61777",
    x1: 126.143,
    y1: 226.25,
    x2: 106.245,
    y2: 184.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3901_61777",
    x1: 147.267,
    y1: 199.121,
    x2: 182.597,
    y2: 234.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2414,
    stopColor: "#F0F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4916,
    stopColor: "#E4F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#CFE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3901_61777",
    x1: 108.062,
    y1: 54.4981,
    x2: 108.062,
    y2: 119.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3901_61777",
    x1: 171.721,
    y1: 54.4981,
    x2: 171.721,
    y2: 119.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3901_61777",
    x1: 108.062,
    y1: 76.6434,
    x2: 108.062,
    y2: 141.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3901_61777",
    x1: 171.721,
    y1: 76.6434,
    x2: 171.721,
    y2: 141.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3901_61777",
    x1: 108.062,
    y1: 98.7879,
    x2: 108.062,
    y2: 164.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3901_61777",
    x1: 171.721,
    y1: 98.7879,
    x2: 171.721,
    y2: 164.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3901_61777",
    x1: 108.062,
    y1: 120.933,
    x2: 108.062,
    y2: 186.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3901_61777",
    x1: 171.721,
    y1: 120.933,
    x2: 171.721,
    y2: 186.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3901_61777",
    x1: 108.062,
    y1: 143.077,
    x2: 108.062,
    y2: 208.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3901_61777",
    x1: 171.721,
    y1: 143.077,
    x2: 171.721,
    y2: 208.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3901_61777",
    x1: 108.062,
    y1: 165.222,
    x2: 108.062,
    y2: 230.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3901_61777",
    x1: 171.721,
    y1: 165.222,
    x2: 171.721,
    y2: 230.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3901_61777",
    x1: 134.096,
    y1: 46.9476,
    x2: 114.091,
    y2: 26.9416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3901_61777",
    x1: 151.398,
    y1: 64.2484,
    x2: 131.366,
    y2: 44.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3901_61777",
    x1: 107.454,
    y1: 20.3055,
    x2: 141.432,
    y2: 54.2831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#FC5F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4805,
    stopColor: "#F7535F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7289,
    stopColor: "#EF3E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    stopColor: "#E5212F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3901_61777",
    x1: 93.3724,
    y1: 187.157,
    x2: 63.5253,
    y2: 156.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3901_61777",
    x1: 36.5483,
    y1: 138.808,
    x2: 57.3325,
    y2: 159.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1814,
    stopColor: "#94E3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3695,
    stopColor: "#88DCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5605,
    stopColor: "#73D1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7537,
    stopColor: "#56C1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9467,
    stopColor: "#31ACFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3901_61777",
    x1: 43.5673,
    y1: 159.336,
    x2: 58.0385,
    y2: 147.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3901_61777",
    x1: 27.4096,
    y1: 161.112,
    x2: 10.8389,
    y2: 177.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3901_61777",
    x1: 73.9752,
    y1: 120.913,
    x2: 73.9752,
    y2: 167.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3901_61777",
    x1: 55.5981,
    y1: 110.8,
    x2: 39.0578,
    y2: 127.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3901_61777",
    x1: 130.255,
    y1: 153.982,
    x2: 130.255,
    y2: 200.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3901_61777",
    x1: 111.893,
    y1: 188.121,
    x2: 95.3396,
    y2: 204.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3901_61777",
    x1: 103.767,
    y1: 207.606,
    x2: 88.7853,
    y2: 192.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    stopColor: "#FE9738",
    stopOpacity: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#FE9738",
    stopOpacity: 0.065
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    stopColor: "#FE9738",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5018,
    stopColor: "#FE9738",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    stopColor: "#FE9738",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    stopColor: "#FE9738",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#FE9738",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3901_61777",
    x1: 83.4018,
    y1: 178.117,
    x2: 83.4018,
    y2: 212.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3901_61777",
    x1: 49.2494,
    y1: 186.961,
    x2: 37.2682,
    y2: 201.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPrescription);
export default __webpack_public_path__ + "static/media/empty-prescription.c2e2557f664bcd2c534f337f2e17f164.svg";
export { ForwardRef as ReactComponent };